// Сбрасывает только сохранённое (persisted) состояние Redux, не трогая
// работающий стор. В отличие от hardResetRedux, который дополнительно
// диспатчит resetStore/resetApiState и на кадр перерисовывает всё приложение
// пустым состоянием (заметное мерцание), здесь стор остаётся как есть до
// полной перезагрузки страницы. Используется перед window.location.replace,
// когда приложение всё равно поднимется заново уже со свежими данными.
export async function purgePersistedRedux(): Promise<void> {
  const { persistor } = await import('@app/store');

  // pause() глушит подписчика redux-persist, чтобы старое состояние не
  // записалось обратно в интервал между purge() и перезагрузкой.
  persistor.pause();
  await persistor.purge();
}
